module.exports = __webpack_public_path__ + "static/overview-whats-4@2x-b28e7aa2096ef46ca70a696381e0dd39.png";